var _style, _path, _rect, _circle, _circle2, _circle3, _path2, _polygon, _path3, _circle4, _path4, _path5, _path6, _polygon2, _path7, _path8, _path9, _path10, _path11, _ellipse, _path12, _path13, _path14, _path15, _circle5, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMainAlternative(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 624.4 433.4",
    style: {
      enableBackground: "new 0 0 624.4 433.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3F3D56;}\n\t.st1{fill:#2F2E41;}\n\t.st2{fill:#FFB8B8;}\n\t.st3{fill:#6C63FF;}\n\t.st4{fill:#A0616A;}\n\t.st5{fill:#CCCCCC;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M615.7,4.6H8.7C3.9,4.6,0,8.5,0,13.3v411.3c0,4.8,3.9,8.7,8.7,8.7h607c2.6,0,5-1.1,6.6-3.1 c0.1-0.1,0.1-0.2,0.2-0.2c0.5-0.6,0.9-1.3,1.3-2.1c0.4-1,0.7-2.2,0.7-3.3V13.3C624.4,8.5,620.5,4.6,615.7,4.6z M622,424.6 c0,1.2-0.4,2.4-1,3.4c-0.6,0.9-1.4,1.6-2.4,2.1c-0.9,0.5-1.9,0.7-2.9,0.7H8.7c-3.4,0-6.2-2.8-6.2-6.2V13.3c0-3.4,2.8-6.2,6.2-6.2 h607c3.4,0,6.2,2.8,6.2,6.2V424.6z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.2,
    y: 39.5,
    className: "st0",
    width: 622,
    height: 2.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 22.4,
    cy: 23.3,
    r: 7.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 43.9,
    cy: 23.3,
    r: 7.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 65.4,
    cy: 23.3,
    r: 7.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M277,251.5c-7.5-4.9-11.2-16.2-9.4-26.5s8.7-19.3,17-23.1c8.2-3.7,17.7-3,25.2,1.8c7.6,4.6,18.3,7.2,21.9,16.5 c2.8,7.1-0.7,21.6-4.5,28.5c-3.2,6-9.3,8.7-15.1,9.9c-12.9,2.6-26.2-0.5-36.7-8.5L277,251.5z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "273.1,306.4 267.1,316.7 266.3,318.1 265.2,320.1 247.5,320.1 248.7,318.1 251.8,312.9 259,300.8  267.1,304 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M246.2,320.1l-3.2-2l-0.4-0.3l20.2-36.8c1.8-3.2,4.7-5.6,8.3-6.6c2.2-0.7,4.5-0.7,6.8-0.3 c1.3,0.3,2.6,0.7,3.7,1.4c0.5,0.3,0.9,0.6,1.4,0.9c1.7,1.2,3.1,2.8,4.1,4.6c2.4,4.4,2.2,9.7-0.4,14l-7.8,12.5l-6.7,10.7l-1.3,2 L246.2,320.1L246.2,320.1z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 298.1,
    cy: 240,
    r: 24.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M322.8,320.1h-55.2l0.3-0.7c-0.1-0.4-0.3-0.9-0.4-1.3c-0.1-0.5-0.2-0.9-0.3-1.4c-0.9-4.2-0.9-8.5,0-12.7 c3.1-15,15.2-27.2,15.2-27.2c0.2-0.2,0.4-0.3,0.6-0.5c1.8-1.3,3.8-2.4,5.9-3.3c9-3.8,18.5-2.2,24.9-0.3c2.2,0.7,4.4,1.5,6.5,2.5 c0.7,0.3,1.1,0.6,1.1,0.6l0.6,19.2l0.8,23L322.8,320.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M348.3,318.1l-4.2-21.5l-4.3-21.6c-0.4-1.8-1.8-3.2-3.7-3.6l-8.9-1.5l-8.3-1.4c-1.6-0.3-3.3,0.3-4.3,1.7 c-0.6,0.8-1,1.7-1,2.7c0,0.6,0.1,1.2,0.4,1.8c4.3,10.1,4.4,26.1,3.3,43.5c0,0.7-0.1,1.3-0.1,2h31.5L348.3,318.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M288.8,273.1c-0.6-2.4-3.1-3.9-5.5-3.3c-0.6,0.2-1.2,0.4-1.7,0.8l-3.8,3.5l-15.7,14.3c-0.5,0.4-0.9,1-1.1,1.6 c-1.8,4.2-5.2,12.6-9.2,22.9c-0.6,1.7-1.3,3.4-2,5.2c-0.2,0.7-0.5,1.3-0.8,2h25.8c0.2-0.7,0.4-1.3,0.6-2c1.1-3.6,2.3-7.2,3.4-10.7 c3.2-10,6-19.2,8.2-26.4c0.6-2,1.2-3.8,1.7-5.5C289,274.7,289,273.9,288.8,273.1z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "354.1,320.1 355.8,320.1 355.6,319.5 355,318.1 345.5,295.8 344.1,296.6 332.5,303.6 338.5,318.1  339.3,320.1 348.7,320.1 "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M344.6,278.1c-2.6-6.9-10.3-10.5-17.3-8.2c-0.4,0.1-0.9,0.3-1.3,0.5c-2.4,1.1-4.4,2.8-5.8,4.9 c-0.6,0.9-1.1,1.8-1.4,2.8c-1.3,3.4-1.2,7.2,0.3,10.6l2.9,6.4l10.3,23l0.9,2h20.9l1.4-0.6l3.7-1.4l0.5-0.2L344.6,278.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M317.4,211.8c1.8,0.5,3.7-0.2,4.6-1.8c0.9-1.6,1-3.5,0.3-5.1c-0.7-1.6-1.8-3.1-3.2-4.2 c-1.6-1.4-3.5-2.4-5.6-2.9c-2.1-0.5-4.3,0-6.1,1.3c-1.7,1.4-2.4,3.6-1.8,5.7c0.6,1.8,2.4,3.1,4.1,4c3.4,1.8,7.2,2.9,11,3.1 L317.4,211.8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M322.2,239.2c-3.9,0.5-3.4-1.5-5-5.1s-3.7-8-7.7-8.4c-3.3-0.3-5.9,2.3-8.6,4.2c-4.7,3.4-11,5.1-16.5,3.1 s-9.2-8.6-7.2-14c1.3-3,3.8-5.4,6.9-6.5c3.1-1.1,6.4-1.6,9.6-1.3c7.3,0.2,14.4,2.1,20.9,5.3c4.5,2.3,8.8,5.5,10.5,10.2 s2.8,11.4-2,12.6L322.2,239.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315.4,198.8c-2-3.4-0.3-8.1,2.9-10.3s7.5-2.5,11.3-1.6c7.7,1.9,13.7,7.8,15.9,15.4c1.6,5.9,0.7,12.3,2,18.3 c3,12.9,15.8,21.1,28.8,18.1c0.5-0.1,1-0.2,1.4-0.4c4.1-1.2,8.3-4.1,8.7-8.4c0.9,10-4.7,19.5-13.9,23.5c-5.3,2.2-11.2,2.3-16.9,2.2 c-3.7-0.1-7.5-0.3-11-1.8c-4.8-2.2-8.5-6.2-10.3-11.2c-1.8-4.9-2.2-10.3-1.4-15.4c0.6-4,1.7-8,2-12s-0.3-8.4-2.8-11.6 s-7.3-4.8-10.8-2.9c-1.4,0.8-2.6,2.1-4.1,2.6s-3.8-0.4-3.6-2L315.4,198.8z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M483,320.1l0.2-2l5.6-58.7c1.8-1.4,3.8-2.7,5.9-3.8c11.6-5.8,22.8-3,28.9-0.6c1.6,0.6,3.2,1.4,4.6,2.3l3.3,60.8 l0.1,2H483z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1602 -0.9871 0.9871 0.1602 211.4109 686.9617)",
    className: "st2",
    cx: 509.4,
    cy: 219.2,
    rx: 24.6,
    ry: 24.6
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M529.3,234.2c5.1-5.4,4.9-13.8-0.5-18.9c-2.6-2.5-6.1-3.8-9.6-3.7c-3.4,0.1-6.6,1.5-9.8,2.5 c-4.9,1.7-10.2,2.1-15.3,1.4c-5.2-0.8-9.8-3.6-13-7.7c-3-4.2-4-10-1.8-14.7c2.5-5.4,8.3-8.4,13.7-10.8c2.2-1.1,4.5-1.9,7-2.3 c2.5-0.4,5,0.2,6.9,1.7c1.5,1.3,2.4,3.3,4.1,4.4c1.9,1.3,4.3,1.3,6.6,1.5c13.9,1.4,24,13.7,22.6,27.6c-0.7,7.2-4.5,13.7-10.4,18 L529.3,234.2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M498.4,265.8l-3.7-10.2l-0.2-0.6c-0.4-1.1-1.6-1.7-2.7-1.3c-0.2,0.1-0.3,0.1-0.5,0.2l-4.2,2.8 c0,0-26.6,0-28.8,16c0,0.3-0.1,0.5-0.1,0.8c0,0,0,0,0,0c-0.3,1-5.3,20.5-9.6,44.5c-0.1,0.7-0.2,1.3-0.4,2h57.9v0 C508.2,296,507.1,273.6,498.4,265.8z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M567.5,318.1c-3.2-24.6-7.7-44.5-7.7-44.5c0-0.3-0.1-0.6-0.1-0.8c-2.1-16-28.8-16-28.8-16l-4.2-2.8 c-1-0.6-2.3-0.4-2.9,0.6c-0.1,0.1-0.2,0.3-0.2,0.5l-3.9,10.8c-8.7,7.8-9.7,30.2-7.8,54.3l0,0h55.8 C567.7,319.4,567.6,318.8,567.5,318.1z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M98.4,262l-5.9,56.1l-0.2,2H76.2c0.2-0.7,0.4-1.3,0.6-2c4.6-15.6,10.8-38.5,10.1-44.5c-1-9.4,6.3-12.6,6.3-12.6 l0.5,0.1L98.4,262z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 124.3,
    cy: 220.2,
    r: 24.6
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M156.1,308.2c-1.2,2.3-2.3,4.7-3,7.2c-0.3,0.9-0.6,1.8-0.8,2.7c-0.2,0.7-0.4,1.3-0.5,2H87 c0.1-0.7,0.2-1.3,0.3-2c3.3-26.2,6-52.7,6.4-57c0-0.4,0.1-0.6,0.1-0.6c38.8-20.5,67.1,6.3,67.1,6.3s0,0.2,0.1,0.6 C161.6,271.1,164.7,292.9,156.1,308.2z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M153.1,315.4l-4.3-9.3l1-36.7l11.1-2.1l0.4-0.1c5.7,3.3,10.2,8.5,12.6,14.7c2.2,5.4,6.3,21.6,9.7,36.1 c0.2,0.7,0.3,1.3,0.5,2h-28.9l-0.9-2L153.1,315.4z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M192.6,155.1h-142c-6.3,0-11.5,5.1-11.5,11.5v142c0,6.3,5.1,11.5,11.5,11.5h142c6.3,0,11.5-5.1,11.5-11.5v-142 C204.1,160.2,199,155.1,192.6,155.1z M202.1,308.6c0,5.2-4.3,9.5-9.5,9.5h-142c-5.2,0-9.5-4.3-9.5-9.5v-142c0-5.2,4.3-9.5,9.5-9.5 h142c5.2,0,9.5,4.3,9.5,9.5L202.1,308.6z M92.5,318.1l-0.2,2h59.5c0.2-0.7,0.3-1.3,0.5-2H92.5z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M383.2,155.1h-142c-6.3,0-11.5,5.1-11.5,11.5v142c0,6.3,5.1,11.5,11.5,11.5h142c6.3,0,11.5-5.1,11.5-11.5v-142 C394.7,160.2,389.6,155.1,383.2,155.1z M392.7,308.6c0,5.2-4.3,9.5-9.5,9.5h-142c-5.2,0-9.5-4.3-9.5-9.5v-142c0-5.2,4.3-9.5,9.5-9.5 h142c5.2,0,9.5,4.3,9.5,9.5V308.6z M267.4,318.1c0.1,0.4,0.3,0.9,0.4,1.3l-0.3,0.7h49.7c0.1-0.7,0.1-1.3,0.1-2H267.4z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M573.8,155.1h-142c-6.3,0-11.5,5.1-11.5,11.5v142c0,6.3,5.1,11.5,11.5,11.5h142c6.3,0,11.5-5.1,11.5-11.5v-142 C585.3,160.2,580.2,155.1,573.8,155.1z M583.3,308.6c0,5.2-4.3,9.5-9.5,9.5h-142c-5.2,0-9.5-4.3-9.5-9.5v-142c0-5.2,4.3-9.5,9.5-9.5 h142c5.2,0,9.5,4.3,9.5,9.5V308.6z M506.4,318.1c0,0.7-0.1,1.3-0.1,2h43.1c0.1-0.7,0.2-1.3,0.3-2H506.4z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M477.2,378.1h-330c-4.4,0-8-3.6-8-8s3.6-8,8-8h330c4.4,0,8,3.6,8,8S481.6,378.1,477.2,378.1z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M384.7,113.1h-145c-4.4,0-8-3.6-8-8s3.6-8,8-8h145c4.4,0,8,3.6,8,8S389.1,113.1,384.7,113.1z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136.1,241.6c1.7,1.7,4.4,1.9,6.3,0.4c5.8-4.3,10.9-9.6,13.9-16.1c3.4-7.5,3.8-16.6-0.3-23.7 c-3.5-6-9.7-9.9-15.9-13c-2.4-1.4-5-2.4-7.7-3c-2.7-0.6-5.6-0.1-8,1.3c-2.4,1.5-3.6,4.3-3.1,7.1c-3-3.4-6.8-5.9-11-7.4 c-2.7-1-5.6-1.3-8.4-0.6c-3.9,1.1-6.8,4.6-8.4,8.4c-1.3,2.9-1.7,6-1.3,9.1c0.5,3.1,2.2,5.9,4.9,7.6c3.2,2,7.4,1.9,11.1,1 s7.3-2.2,11.1-2.6s8,0.6,10.3,3.6c1.6,2.1,2,4.9,2.4,7.6l1.9,13.8c0.2,2,0.7,4,1.5,5.8C135.7,241.1,135.9,241.4,136.1,241.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainAlternative);
export default __webpack_public_path__ + "static/media/main-alternative.011c955f11412282e347b36c677a73ad.svg";
export { ForwardRef as ReactComponent };